import React, { Component } from "react";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import UserService from "../../services/UserService";
import DispatchService from "../../services/DispatchService";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import tableRequest from "../../models/tableRequest.js";
import { confirmAlert } from "react-confirm-alert";
import { ConfirmationModal } from "../../template/ConfirmationModal";
import MessageComponent from "../../template/Message";
import $ from "jquery";
import PrintDispatchService from "../../services/PrintDispatchService";
import ApiService from "../../services/apiService";
import WareHouseMaterService from '../../services/WareHouseMaterService';
import Loaders from '../../template/Loaders';

export default class DealerDispatch extends Component {
  constructor(props) {
    super(props);
    this.UserService = new UserService();
    this.DispatchService = new DispatchService();
    this.PrintDispatchService = new PrintDispatchService();
    this.ApiService = new ApiService();
    this.WareHouseMaterService = new WareHouseMaterService();
    this.tblResponse = new tableRequest();
    this.state = {
      // PLC Conveyor Control State - Load from cache
      plcIp: localStorage.getItem("plcIp") || "",
      plcPort: localStorage.getItem("plcPort") || 502,
      isPlcConnected: false,
      isConveyorRunning: false,
      conveyorStatus: "Disconnected",
      
      // Existing state
      scanTxt: '',
      warehouseVisible: true,
      visible: false,
      dialogVisible: false,
      showModal: false,
      selectedBatch: '',
      selectedDeliveryId: null,
      cartoonLoader: false,
      DeliveryId: null,
      scanItemLoader: true,
      remarkVisible: false,
      eventBlock: false,
      sortIcon: false,
      sortOrder: "1",
      Batch: '', 
      DeliveryNo: '', 
      selectedDeliveryDetailId: '',
      formError: {},
      UserDDL: [],
      SelectedDDL: [],
      wareHouseDDL: [],
      WareHouseFactoryDDL: [],
      SendTo: [],
      SONumber: '',
      buttonLabel: "Submit",
      DeliveryDetailId: null,
      DeliveryOptions: [],
      batchData: [],
      BatchId: null,
      BatchOptions: [],
      sales: [],
      batchDetailsByDeliveryId: [],
      scanItems: [],
      loading: true,
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      emptyMessage: "No Data found",
      emptyMessage1: "No Previous Scanned Data found !!",
      bill_Address1: "",
      bill_Address2: "",
      bill_City: "",
      bill_Country: "",
      ship_to_Party: "",
      ship_to_Party_Name: "",
      bill_Pincode: "",
      bill_State: "",
      ship_Address1: "",
      ship_Address2: "",
      ship_City: "",
      ship_Country: "",
      ship_Pincode: "",
      ship_State: "",
      IsOldProduct: false,
      Remark: "",
      needtoSaveDispatch: "",
      plant: "",
      batchStorageLocations: [],
      TotalCaseCount: 0,
      TotalData: 0,
      isAdmin: false,
      shipToParty: "",
      shipToPartyName: "",
      billType: "",
      // Pagination state for batch details table
      batchDetailsFirst: 0,
      batchDetailsRows: 10,
      batchDetailsTotalRecords: 0,
      // Status Report State
      statusReportVisible: false,
      statusReportData: [],
      statusReportLoading: false,
      isFetchingStatusReport: false
    };

    // Bind methods
    this.hideFunc = this.hideFunc.bind(this);
    this.actionTemplate = this.actionTemplate.bind(this);
    this.actionTemplate1 = this.actionTemplate1.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleScanChange = this.handleScanChange.bind(this);
    this.handleBatchChange = this.handleBatchChange.bind(this);
    this.ScanItem = this.ScanItem.bind(this);
    this.setCartonDetails = this.setCartonDetails.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.submitRemark = this.submitRemark.bind(this);
    this.onPage = this.onPage.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.onSort = this.onSort.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.RemoveDataFromTempScannedRecords = this.RemoveDataFromTempScannedRecords.bind(this);
    this.handleUpdateButtonClick = this.handleUpdateButtonClick.bind(this);
    this.onBatchDetailsPage = this.onBatchDetailsPage.bind(this);
    this.openStatusReport = this.openStatusReport.bind(this);
    this.closeStatusReport = this.closeStatusReport.bind(this);
    
    // PLC Methods
    this.handlePlcIpChange = this.handlePlcIpChange.bind(this);
    this.handlePlcPortChange = this.handlePlcPortChange.bind(this);
    this.connectToPlc = this.connectToPlc.bind(this);
    this.startConveyor = this.startConveyor.bind(this);
    this.stopConveyor = this.stopConveyor.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    
    // Create ref for scan input
    this.scanInputRef = React.createRef();
  }

  componentDidMount() {
    const isAdmin = sessionStorage.getItem("IsAdmin") === 'true';
    this.setState({ isAdmin });
    console.log('isAdmin:', isAdmin);
    
    // Load PLC settings from cache
    const cachedPlcIp = localStorage.getItem("plcIp");
    const cachedPlcPort = localStorage.getItem("plcPort");
    
    if (cachedPlcIp) {
      this.setState({ plcIp: cachedPlcIp });
    }
    if (cachedPlcPort) {
      this.setState({ plcPort: parseInt(cachedPlcPort) || 502 });
    }
    
    setTimeout(() => {
      this.GetDispatch();
      this.GetWareHouse();
    }, 1000);

    $(".p-column-title").on("click", function () {
      $(this)
        .next()
        .removeClass("pi-sort")
        .toggleClass("pi-sort-up")
        .addClass("pi-sort-down");
    });

    this.GetActiveUsers();
    
    if (this.ApiService.getUserType() == 1) {
      this.setState({
        visible: true,
      });
    }
    
    // Auto-focus on scan input after component mounts
    setTimeout(() => {
      if (this.scanInputRef.current) {
        this.scanInputRef.current.focus();
      }
    }, 500);
  }

  // Status Report Methods
  openStatusReport = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    const { DeliveryId, isFetchingStatusReport } = this.state;
    
    if (!DeliveryId) {
      this.refs.Messchild.showWarn("Please select a Delivery No first");
      return;
    }
    
    if (isFetchingStatusReport) {
      return;
    }
    
    this.setState({ 
      statusReportVisible: true, 
      statusReportLoading: true,
      statusReportData: [],
      isFetchingStatusReport: true
    });
    
    this.DispatchService.GetDeliveryStatus(DeliveryId)
      .then((data) => {
        const resdata = data.data;
        
        if (resdata && resdata.ResponseCode === "200") {
          const responseData = resdata.ResponseData || [];
          this.setState({
            statusReportData: Array.isArray(responseData) ? responseData : [],
            statusReportLoading: false,
            isFetchingStatusReport: false
          });
        } else {
          const errorMessage = resdata?.ResponseMessage || "Failed to fetch status report";
          this.refs.Messchild.showWarn(errorMessage);
          this.setState({
            statusReportData: [],
            statusReportLoading: false,
            isFetchingStatusReport: false
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching status report:", error);
        this.refs.Messchild.showError("Error fetching status report: " + (error.message || "Unknown error"));
        this.setState({
          statusReportData: [],
          statusReportLoading: false,
          isFetchingStatusReport: false
        });
      });
  }

  closeStatusReport = () => {
    this.setState({ 
      statusReportVisible: false, 
      statusReportData: [],
      statusReportLoading: false,
      isFetchingStatusReport: false
    });
  }

  // Status Report Table Column Templates
  statusStatusTemplate = (rowData) => {
    if (!rowData) return null;
    
    const status = rowData.Status;
    let statusClass = "";
    let statusIcon = "";
    
    if (status === "Scanned") {
      statusClass = "bg-success text-white";
      statusIcon = "pi pi-check-circle";
    } else if (status === "Partially Scanned") {
      statusClass = "bg-warning text-dark";
      statusIcon = "pi pi-clock";
    } else if (status === "Not Scanned") {
      statusClass = "bg-danger text-white";
      statusIcon = "pi pi-times-circle";
    } else {
      statusClass = "bg-secondary text-white";
      statusIcon = "pi pi-question-circle";
    }
    
    return (
      <span className={`status-badge p-2 rounded ${statusClass}`}>
        <i className={`${statusIcon} mr-2`}></i>
        {status || "Unknown"}
      </span>
    );
  };

  // PLC Control Methods
  handlePlcIpChange(e) {
    const ipValue = e.target.value;
    this.setState({ plcIp: ipValue });
    localStorage.setItem("plcIp", ipValue);
  }

  handlePlcPortChange(e) {
    const portValue = e.target.value;
    this.setState({ plcPort: parseInt(portValue) || 502 });
    localStorage.setItem("plcPort", portValue);
  }

  connectToPlc() {
    const { plcIp, plcPort } = this.state;
    
    if (!plcIp) {
      this.refs.Messchild.showWarn("Please enter PLC IP address");
      return;
    }

    const plcAddress = {
      PlcIp: plcIp,
      PlcPort: plcPort,
      RegisterNumber: 5,
      Signal: 0
    };

    this.DispatchService.ConnectToPLC(plcAddress).then((data) => {
      const resdata = data.data;
      if (resdata !== null && resdata.ResponseCode === "200") {
        this.setState({ 
          isPlcConnected: true,
          conveyorStatus: "Connected"
        });
        this.refs.Messchild.showSuccess("PLC Connected Successfully");
        
        if (this.scanInputRef.current) {
          this.scanInputRef.current.focus();
        }
      } else {
        this.setState({ 
          isPlcConnected: false,
          conveyorStatus: "Connection Failed"
        });
        this.refs.Messchild.showError(resdata.ResponseMessage || "Failed to connect to PLC");
      }
    }).catch((error) => {
      this.setState({ 
        isPlcConnected: false,
        conveyorStatus: "Connection Error"
      });
      this.refs.Messchild.showError("PLC Connection Error: " + error.message);
    });
  }

  startConveyor() {
    const { plcIp, plcPort, isPlcConnected, DeliveryId } = this.state;
    
    if (!isPlcConnected) {
      this.refs.Messchild.showWarn("Please connect to PLC first");
      return;
    }

    if (!DeliveryId) {
      this.refs.Messchild.showWarn("Please select a Delivery No first");
      return;
    }

    const plcAddress = {
      PlcIp: plcIp,
      PlcPort: plcPort,
      RegisterNumber: 5,
      Signal: 1
    };
    
    this.starttimer();
    this.DispatchService.StartConveyor(plcAddress).then((data) => {
      const resdata = data.data;
      if (resdata !== null && resdata.ResponseCode === "200") {
        this.Removetimer();
        this.setState({ 
          isConveyorRunning: true,
          conveyorStatus: "Running"
        });
        this.refs.Messchild.showSuccess("Conveyor Started Automatically");
        
        if (this.scanInputRef.current) {
          this.scanInputRef.current.focus();
        }
      } else {
        this.refs.Messchild.showError(resdata.ResponseMessage || "Failed to start conveyor");
      }
    }).catch((error) => {
      this.refs.Messchild.showError("Error starting conveyor: " + error.message);
    });
  }

  stoptimer() {
    const { plcIp, plcPort, isPlcConnected } = this.state;
    
    if (!isPlcConnected) {
      return;
    }

    const plcAddress = {
      PlcIp: plcIp,
      PlcPort: plcPort,
      RegisterNumber: 5,
      Signal: 1
    };
    
    this.DispatchService.Stop(plcAddress).then((data) => {
    }).catch((error) => {
      console.error("Timer stop error:", error);
    });
  }

  starttimer() {
    const { plcIp, plcPort, isPlcConnected } = this.state;
    
    if (!isPlcConnected) {
      return;
    }

    const plcAddress = {
      PlcIp: plcIp,
      PlcPort: plcPort,
      RegisterNumber: 5,
      Signal: 1
    };

    this.DispatchService.Start(plcAddress).then((data) => {
    }).catch((error) => {
      console.error("Timer start error:", error);
    });
  }

  Removetimer() {
    const { plcIp, plcPort, isPlcConnected } = this.state;
    
    if (!isPlcConnected) {
      return;
    }

    const plcAddress = {
      PlcIp: plcIp,
      PlcPort: plcPort,
      RegisterNumber: 5,
      Signal: 1
    };

    this.DispatchService.StopTimer(plcAddress).then((data) => {
    }).catch((error) => {
      console.error("Timer remove error:", error);
    });
  }

  stopConveyor() {
    const { plcIp, plcPort, isPlcConnected } = this.state;
    
    if (!isPlcConnected) {
      return;
    }

    const plcAddress = {
      PlcIp: plcIp,
      PlcPort: plcPort,
      RegisterNumber: 5,
      Signal: 0
    };
    
    this.stoptimer();
    this.DispatchService.StopConveyor(plcAddress).then((data) => {
      const resdata = data.data;
      if (resdata !== null && resdata.ResponseCode === "200") {
        this.setState({ 
          isConveyorRunning: false,
          conveyorStatus: "Stopped"
        });
      } else {
        this.refs.Messchild.showError(resdata.ResponseMessage || "Failed to stop conveyor");
      }
    }).catch((error) => {
      this.refs.Messchild.showError("Error stopping conveyor: " + error.message);
    });
  }

  validateScannedMaterial(scanData) {
    const { batchDetailsByDeliveryId, plant, batchStorageLocations } = this.state;
    
    const matchingDetail = batchDetailsByDeliveryId.find(detail =>
      detail.MaterialCode === scanData.MaterialCode
    );

    if (!matchingDetail) {
      this.refs.Messchild.showWarn("Material code mismatch !!");
      this.stopConveyor();
      return { isValid: false, message: "Material code mismatch!" };
    }

    if (scanData.Plant !== plant) {
      this.refs.Messchild.showWarn("Invalid Plant");
      this.stopConveyor();
      return { isValid: false, message: "Invalid Plant" };
    }

    if (!batchStorageLocations.includes(scanData.StorageLocation)) {
      this.refs.Messchild.showWarn("Invalid Storage Location");
      this.stopConveyor();
      return { isValid: false, message: "Invalid Storage Location" };
    }

    if (matchingDetail.Cases <= 0) {
      this.refs.Messchild.showWarn("No remaining cases for this material");
      this.stopConveyor();
      return { isValid: false, message: "No remaining cases for this material" };
    }

    return { isValid: true, message: "Valid scan", matchingDetail };
  }

  setCartonDetails(deliveryNo, uid, createdby) {
    this.DispatchService.GetDeliveryNoItemScan(deliveryNo, uid, createdby)
      .then((data) => {
        const resdata = data?.data;

        if (!resdata) {
          this.stopConveyor();
          this.refs.Messchild.showWarn("No response from server");
          return;
        }
debugger
        if (resdata.ResponseCode === "200") {
          const res = resdata.ResponseData?.[0];

          this.setState({ scanTxt: "" });

          this.GetTempDataForDispatch(this.state.DeliveryId);

          this.refs.Messchild.showSuccess("Scan successful");

          const updatedBatchDetails = resdata.ResponseData || [];
          const totalRemainingCases = updatedBatchDetails.reduce(
            (sum, detail) => sum + (detail.Cases || 0),
            0
          );

          if (totalRemainingCases === 0) {
            this.stopConveyor();
            this.refs.Messchild.showSuccess("All items scanned! Conveyor stopped.");
          }

          if (this.scanInputRef?.current) {
            this.scanInputRef.current.focus();
          }
        }
        else {
          this.stopConveyor();
          this.refs.Messchild.showWarn(
            resdata.ResponseMessage || "Invalid scan"
          );
        }
      })
      .catch((error) => {
        this.stopConveyor();
        console.error("Scan API failed:", error);
        this.refs.Messchild.showError(
          "Scan error: " + (error.message || "Unexpected error")
        );
      });
  }

  hideFunc() {
    this.setState({
      remarkVisible: false,
      visible: false
    })
  }

  onPage(event) {
    this.setState({
      loading: true,
    });

    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.GetDispatch();
    }, 250);
  }

  onBatchDetailsPage(event) {
    this.setState({
      batchDetailsFirst: event.first,
      batchDetailsRows: event.rows
    });
  }

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  GetDispatch() {
    this.setState({ cartoonLoader: false });
    this.tblResponse.SortColumn = 'CreatedDt';
    this.DispatchService.GetDispatch(this.tblResponse).then((data) => {
      const resdata = data.data;
      this.setState({ cartoonLoader: true });
      
      if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
        this.datasource = resdata.ResponseData;
        this.setState({
          totalRecords: resdata.ResponseData[0].TotalRows,
          first: (this.tblResponse.First - 1),
          sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
          loading: false,
        });
      } else {
        this.datasource = null;
        this.setState({
          totalRecords: 0,
          first: 1,
          sales: null,
          loading: false,
        });
      }
    });
  }

  handleChange = (e) => {
    const selectedDeliveryId = e.value;
    const selectedDelivery = this.state.DeliveryOptions.find(option => option.value === e.value);
    
    if (this.state.isConveyorRunning) {
      this.stopConveyor();
    }

    this.setState({
      DeliveryId: selectedDeliveryId,
      DeliveryNo: selectedDelivery.label,
      shipToParty: selectedDelivery.ship_to_Party,
      shipToPartyName: selectedDelivery.ship_to_Party_Name,
      plant: selectedDelivery.plant,
      billType: selectedDelivery.billType,
      scanItems: [],
      batchDetailsFirst: 0
    });
    
    this.GetBatchDDL(selectedDeliveryId);
    this.GetTempDataForDispatch(selectedDeliveryId);
    
    if (this.state.isPlcConnected) {
      setTimeout(() => {
        this.startConveyor();
      }, 100);
    } else {
      if (this.scanInputRef.current) {
        this.scanInputRef.current.focus();
      }
    }
  }

  handleScanChange(e) {
    this.setState({ scanTxt: e.target.value });
  }

  validateForm(value, name) {
    let errors = this.state.formError;
    let IsValid = true;
    
    switch (name) {
      case "UserName":
        if (value.length < 1) {
          IsValid = false;
          errors.UserName = "Please enter your username.";
        } else errors.UserName = "";
        break;
      case "SendTo":
        this.state.bill_Address1 = value.bill_Address1;
        this.state.bill_Address2 = value.bill_Address2;
        this.state.bill_Pincode = value.bill_Pincode;
        this.state.bill_Country = value.bill_CountryName;
        this.state.bill_State = value.bill_StateName;
        this.state.bill_City = value.bill_CityName;
        this.state.ship_Address1 = value.ship_Address1;
        this.state.ship_Address2 = value.ship_Address2;
        this.state.ship_Pincode = value.ship_Pincode;
        this.state.ship_Country = value.ship_CountryName;
        this.state.ship_State = value.ship_StateName;
        this.state.ship_City = value.ship_CityName;
        this.setState({
          eventBlock: true,
        });
        break;
      default:
        break;
    }
    return IsValid;
  }

  formReset() {
    this.setState({
      ReferenceID: "",
      UserName: "",
      FirstName: "",
      LastName: "",
      Email: "",
      MobileNo: "",
      Password: "",
      ConfirmPassword: "",
      IsActive: true,
    });
    let errors = this.state.formError;
    Object.entries(errors).map(([key, value]) => {
      errors[key] = "";
    });
  }

  openDialog() {
    this.setState({
      visible: true,
    });
    this.formReset();
  }

  submitForm(event) {
    event.preventDefault();

    if (this.state.scanItems.length == 0) {
      this.refs.Messchild.showWarn("Scan First");
      return;
    } else if (this.state.TotalCaseCount !== this.state.TotalData) {
      this.refs.Messchild.showWarn("OBD is not completely scanned !!");
      return;
    } else {
      let formData = {};
      formData = {
        TotalQty: this.state.TotalData,
        DeliveryNo: this.state.DeliveryNo,
      };
      this.SaveDispatch(formData);
    }
  }

  submitRemark(event) {
    event.preventDefault();
    let formD = { ...this.state.needtoSaveDispatch };
    formD.Remark = this.state.Remark;
    this.SaveDispatch(formD);
  }

  SaveDispatch(formData) {
    this.setState({ scanItemLoader: false });
    const { DeliveryNo } = this.state;

    const updatedFormData = {
      ...formData,
      DeliveryNo: DeliveryNo
    };
    
    setTimeout(() => {
      this.DispatchService.SaveDepot(updatedFormData).then((data) => {
        this.setState({ scanItemLoader: true });
        const resdata = data.data;
        
        if (resdata !== null && resdata.ResponseCode === "200") {
          this.refs.Messchild.showSuccess(resdata.ResponseMessage);
          this.state.scanItems = [];
          this.setState({
            scanItems: [],
            SendTo: [],
            remarkVisible: false,
            needtoSaveDispatch: "",
            isConveyorRunning: false,
            conveyorStatus: "Stopped"
          });
          this.GetDispatch();
          this.GetWareHouse();
          
          if (this.scanInputRef.current) {
            this.scanInputRef.current.focus();
          }
        } else if (resdata.ResponseCode === "400") {
          this.refs.Messchild.showWarn(resdata.ResponseMessage);
        } else {
          this.refs.Messchild.showError(resdata.ResponseMessage);
        }
      });
    }, 1000);
  }

  handleBatchChange = (e) => {
    this.setState({ Batch: e.target.value });
  }

  actionTemplate1 = (rowData) => {
    return (
      <Button type="button" onClick={() => this.openModal(rowData)} icon="pi pi-pencil" className="p-button-warning" >
      </Button>
    );
  }

  openModal = (rowData) => {
    this.setState({
      visible: true,
      buttonLabel: 'Update',
      formHeading: 'Update User',
      Batch: rowData.Batch,
      selectedDeliveryDetailId: rowData.DeliveryId
    });
  }

  GetActiveUsers() {
    this.UserService.GetAllActiveUsers().then((data) => {
      const resdata = data.data;
      if (resdata !== null && resdata.ResponseCode === "200") {
        this.setState({
          UserDDL: resdata.ResponseData,
        });
      }
    });
  }

  ScanItem(e) {
    if (e.key === 'Enter') {
      let qr = e.target.value;
      var deliveryNo = this.state.DeliveryNo;
      const userId = sessionStorage.getItem('UserId');
      debugger
      if (!this.state.DeliveryId) {
        this.stopConveyor();
        this.refs.Messchild.showWarn("Select Delivery No. - Conveyor Stopped");
        if (this.scanInputRef.current) {
          this.scanInputRef.current.focus();
        }
        return;
      }

      if (!this.state.isConveyorRunning) {
        this.refs.Messchild.showWarn("Conveyor not running. Please wait or select delivery again.");
        if (this.scanInputRef.current) {
          this.scanInputRef.current.focus();
        }
        return;
      }

      if (qr.includes("SID") || qr.includes("di-details") ) {
        this.setCartonDetails(deliveryNo, qr, userId);
      } else {
        this.stopConveyor();
        this.refs.Messchild.showWarn("Invalid Scanned - Conveyor Stopped");
        if (this.scanInputRef.current) {
          this.scanInputRef.current.focus();
        }
      }
      this.setState({
        scanTxt: ""
      });
    }
  }

  GetWareHouse() {
    this.DispatchService.DeliveryDDL().then(data => {
      const resdata = data.data;
      if (resdata && resdata.ResponseData && resdata.ResponseData.length > 0) {
        const deliveries = resdata.ResponseData;
        const deliveryOptions = deliveries.map(delivery => ({
          label: delivery.DeliveryNo,
          value: delivery.DeliveryId,
          ship_to_Party: delivery.ShipToParty,
          ship_to_Party_Name: delivery.ShipToPartyName,
          plant: delivery.Plant,
          billType: delivery.BillType
        }));
        
        this.setState({
          DeliveryOptions: deliveryOptions,
        });
      }
    });
  }

  GetTempDataForDispatch(selectedDeliveryId) {
    this.DispatchService.GetTempDataForDispatch(selectedDeliveryId).then(data => {
      const resdata = data.data;

      if (resdata && resdata.ResponseCode == "200") {
        this.setState({
          scanItems: resdata.ResponseData || [],
          emptyMessage1: resdata.ResponseData && resdata.ResponseData.length === 0 ? "No data available" : "",
          TotalData: resdata.ResponseData.length
        });
      } else {
        this.setState({
          emptyMessage: resdata.ResponseMessage || "Failed to load data",
        });
        this.refs.Messchild.showWarn(resdata.ResponseMessage || "Failed to load data");
      }
    }).catch(error => {
      console.error("API call failed:", error);
      this.setState({
        emptyMessage: "Error occurred while fetching data",
        scanItemLoader: false
      });
      this.refs.Messchild.showWarn("Error occurred while fetching data");
    });
  }

  GetBatchDDL(selectedDeliveryId) {
    this.DispatchService.GetBatchDDL(selectedDeliveryId).then(data => {
      const resdata = data.data;
      if (resdata && resdata.ResponseData && resdata.ResponseData.length > 0) {
        const batchDetails = resdata.ResponseData;

        const totalCases = batchDetails.reduce((sum, detail) => sum + (detail.Cases || 0), 0);

        console.log("Total Cases:", totalCases);
        this.setState({
          TotalCaseCount: totalCases,
          batchDetailsTotalRecords: batchDetails.length
        });

        const batchDetailsWithTotalCases = batchDetails.map(detail => ({
          ...detail,
          TotalCases: detail.Cases,
        }));

        this.batchDetailsByDeliveryId = batchDetailsWithTotalCases;
        
        const { batchDetailsFirst, batchDetailsRows } = this.state;
        const paginatedBatchDetails = batchDetailsWithTotalCases.slice(
          batchDetailsFirst, 
          batchDetailsFirst + batchDetailsRows
        );
        
        this.setState({
          BatchDetails: batchDetailsWithTotalCases,
          BatchOptions: batchDetailsWithTotalCases.map(detail => ({
            label: detail.Batch,
            value: detail.Id,
            TotalCases: detail.Cases,
          })),
          batchStorageLocations: batchDetails.map(b => b.StorageLocation),
          batchDetailsByDeliveryId: paginatedBatchDetails,
          loading: false,
        });
      } else {
        this.setState({
          batchDetailsByDeliveryId: [],
          batchDetailsTotalRecords: 0,
          loading: false,
        });
      }
    });
  }

  handleUpdateButtonClick = () => {
    const { Batch, selectedDeliveryDetailId } = this.state; 
    const formData = { 
      batchNo: Batch, 
      deliveryDetailsId: selectedDeliveryDetailId 
    };
    
    this.DispatchService.UpdateBatchNo(formData).then((data) => {
      const resdata = data.data;
      if (resdata.ResponseCode === "200") {
        this.refs.Messchild.showSuccess(resdata.ResponseMessage);
        this.setState({ visible: false });
      } else if (resdata.ResponseCode === "201") {
        this.refs.Messchild.showWarn(resdata.ResponseMessage);
      } else {
        this.refs.Messchild.showWarn("An unexpected error occurred.");
      }
    }).catch((error) => {
      console.error('Error updating batch:', error);
      this.refs.Messchild.showWarn("Failed to update batch. Please try again.");
    });
  }

  searchFilter(e) {
    this.setState({
      loading: true,
    });
    this.tblResponse.SearchValue = e.target.value;
    this.GetDispatch();
  }

  callbackFunction = (childData) => {
    this.setState({ message: childData });
  };

  onValueChange(event) {
    const val = event.target.value;

    if (val == "Dealer") {
      const Dealer = this.state.UserDDL.filter((x) => x.UserType == 2);
      this.setState({
        SelectedDDL: Dealer,
        warehouseVisible: true,
      });
    }
    if (val == "Distributor") {
      const Distributor = this.state.UserDDL.filter((x) => x.UserType == 1);
      this.setState({
        SelectedDDL: Distributor,
        warehouseVisible: true,
      });
    }
    if (val == "WareHouse") {
      const wareHouse = this.state.WareHouseFactoryDDL.filter((x) => x.IsFactory == 0 && x.IsDepot == 0);
      this.setState({
        wareHouseDDL: wareHouse,
      });
      this.setState({
        warehouseVisible: false,
      });
    }
    if (val == "Factory") {
      const fact = this.state.WareHouseFactoryDDL.filter((x) => x.IsFactory == 1);
      this.setState({
        wareHouseDDL: fact,
        warehouseVisible: false,
      });
    }
    if (val == "Depot") {
      const Depot = this.state.WareHouseFactoryDDL.filter((x) => x.IsDepot == 1);
      this.setState({
        wareHouseDDL: Depot,
        warehouseVisible: false,
      });
    }
  }

  activeTemplate(rowData, column) {
    return <input type="checkbox" disabled checked={rowData.IsActive} />;
  }

  onSort(event) {
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField = event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.GetDispatch();
    const clickData = document.getElementsByClassName(
      "p-sortable-column-icon pi pi-fw pi-sort"
    );
    console.log(event);
  }

  RemoveDataFromTempScannedRecords(id) {
    this.DispatchService.RemoveDataFromTempScannedRecords(id).then(
      (data) => {
        const resdata = data.data;
        if (resdata.ResponseCode == 200) {
          let arrayfilter = this.state.scanItems.filter((x) => x.Id != id);
          this.GetTempDataForDispatch(this.state.DeliveryId);
          this.setState({
            scanItems: arrayfilter,
            totalScans: this.state.totalScans - 1,
          });
          this.state.allscanItems = this.state.scanItems;
        } else {
          this.refs.Messchild.showSuccess(resdata.ResponseMessage);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          return;
        }
      }
    );
  }

  actionTemplate(rowData, column) {
    const deleteFunc = () => {
      confirmAlert({
        title: "Confirm to delete",
        message: "Are you sure to do this.",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.RemoveDataFromTempScannedRecords(rowData.Id),
          },
          {
            label: "No",
            onClick: () => null,
          },
        ],
      });
    };

    return (
      <span>
        <Button type="button" icon="pi pi-trash" onClick={deleteFunc} className="p-button-danger"></Button>
      </span>
    );
  }

  fetchData() {
    this.setState({ dialogVisible: true })
  }

  closeDialog() {
    this.setState({ dialogVisible: false, apiData: [] });
  }

  render() {
    const { plcIp, plcPort, isPlcConnected, isConveyorRunning, conveyorStatus, statusReportVisible, statusReportData, statusReportLoading } = this.state;

    let header = (
      <div className="row">
        <div className="col-md-8 text-left"></div>
      </div>
    );

    let header2 = (
      <div className="row">
        <div className="col-md-4 text-left">
          <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
          <InputText type="search" onInput={this.searchFilter} placeholder="Global Search" size="30" />
        </div>
      </div>
    );

    return (
      <>
        <MessageComponent ref="Messchild" />
        <ConfirmationModal parentCallback={this.callbackFunction} ref="child" />
        
        {/* PLC Conveyor Control Section */}
        <div className="card mb-4">
          <div className="card-header">
            <h3 className="card-title mb-0">
              <i className="pi pi-cog mr-2"></i>
              PLC Conveyor Control
            </h3>
          </div>
          <div className="card-body">
            <div className="row align-items-center">
              <div className="col-md-3">
                <div className="form-group">
                  <label className="font-weight-bold">PLC IP Address:</label>
                  <InputText
                    value={plcIp}
                    onChange={this.handlePlcIpChange}
                    placeholder="Enter PLC IP"
                    className="form-control"
                    disabled={isPlcConnected}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !isPlcConnected && plcIp) {
                        this.connectToPlc();
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label className="font-weight-bold">Port:</label>
                  <InputText
                    value={plcPort}
                    onChange={this.handlePlcPortChange}
                    type="number"
                    className="form-control"
                    disabled={isPlcConnected}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label className="font-weight-bold">Status:</label>
                  <div className={`status-indicator p-2 rounded ${
                    conveyorStatus === "Connected" || conveyorStatus === "Running" ? "bg-success text-white" :
                    conveyorStatus === "Stopped" ? "bg-warning text-dark" :
                    "bg-danger text-white"
                  }`}>
                    <i className={`pi ${
                      conveyorStatus === "Running" ? "pi-play" :
                      conveyorStatus === "Stopped" ? "pi-pause" :
                      "pi-times"
                    } mr-2`}></i>
                    {conveyorStatus}
                    {isConveyorRunning && " - Auto"}
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group mb-0">
                  <label className="font-weight-bold d-block">&nbsp;</label>
                  <div className="btn-group">
                    <Button
                      label={isPlcConnected ? "Connected" : "Connect"}
                      icon="pi pi-link"
                      className={`p-button-${isPlcConnected ? "success" : "primary"} mr-2`}
                      onClick={this.connectToPlc}
                      disabled={isPlcConnected || !plcIp}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="heading">
          <h1>Depot Dispatch</h1>
        </div>
        
        <div className="w-100 px-4 row">
          <div className="form-inline dispatch-label row mb-3">
            <div className="form-group col-md-4">
              <label className="ml-2 mr-2">Delivery No:</label>
              <div className="custom-drop">
                <Dropdown
                  optionLabel="label"
                  onChange={this.handleChange}
                  value={this.state.DeliveryId}
                  className="form-control"
                  placeholder="Select Delivery"
                  name="SendTo"
                  options={this.state.DeliveryOptions}
                  disabled={isConveyorRunning}
                />
                {this.state.formError.SendTo !== null ? (
                  <div className="error">{this.state.formError.SendTo}</div>
                ) : null}
              </div>
            </div>

            <div className="form-group col-md-4">
              <label className="ml-2 mr-2">Scan items:</label>
              <input 
                ref={this.scanInputRef}  
                onChange={e => { this.handleScanChange(e) }} 
                name="scanTxt" 
                value={this.state.scanTxt} 
                type="search"
                className="form-control ml-2" 
                id="scanTxt" 
                onKeyDown={e => { this.ScanItem(e) }}
                placeholder={isConveyorRunning ? "Ready to scan..." : "Select delivery to auto-start conveyor"}
                // disabled={!isConveyorRunning}
                autoFocus  
              />
            </div>

            {/* Status Report Button */}
            <div className="form-group col-md-4 text-right">
              <Button
                label="Status Report"
                icon="pi pi-chart-line"
                className="p-button-info"
                onClick={this.openStatusReport}
                disabled={!this.state.DeliveryId}
                type="button"
              />
            </div>
           
          </div>
        </div>
      
        <div>
          <div className="address-block" >
            <h4 className="mt-3">Shipping address</h4>
            <div className="row dispatch-label mb-3">
              <div className="col-md-3">
                <label><strong>Ship To Party: &nbsp;</strong></label>
                {this.state.shipToParty}
              </div>
              <div className="col-md-3">
                <label><strong>Ship To Party Name: &nbsp;</strong></label>
                {this.state.shipToPartyName}
              </div>
              <div className="col-md-3">
                <label><strong>Plant: &nbsp;</strong></label>
                {this.state.plant}
              </div>
              <div className="col-md-3">
                <label><strong>Bill Type: &nbsp;</strong></label>
                {this.state.billType}
              </div>
            </div>
          </div>
          
          <div className="pb-4">
            <Loaders loader={this.state.cartoonLoader} classType="small" />
            <DataTable 
              responsive={true}
              emptyMessage={this.state.emptyMessage}
              value={this.state.batchDetailsByDeliveryId}
              sortMode="multiple"
              paginator={true}
              rows={this.state.batchDetailsRows}
              rowsPerPageOptions={[5, 10, 20, 50]}
              totalRecords={this.state.batchDetailsTotalRecords}
              first={this.state.batchDetailsFirst}
              onPage={this.onBatchDetailsPage}
              className="tblAuto customertablebg"
            >
              <Column field="LineItem" header="LineItem" />
              <Column field="StorageLocation" header="Storage Location" />
              <Column field="MaterialCode" header="Material Code" />
              <Column field="MaterialDescription" header="Material Description" />
              <Column field="Batch" header="Batch" />
              <Column field="Qty" header="Qty" />
              <Column field="TotalCases" header="Total Cases" />
            </DataTable>
          </div>
        </div>

        <Loaders loader={this.state.scanItemLoader} />
        <DataTable
          responsive={true}
          header={header}
          emptyMessage={this.state.emptyMessage1}
          value={this.state.scanItems}
          sortMode="multiple"
          paginator={false}
          rows={1000}
          className="tblAuto"
        >
          <Column field="SID" header="Carton Id" sortable={true} />
            <Column field="ProductCode" header="Product Code" sortable={true} />
          <Column field="ProductName" header="Product Name" sortable={true} />
          <Column field="BatchNo" header="Batch No" sortable={true} />
          <Column field="TotalQty" header="Carton Qty" sortable={true} />
          <Column field="ScannedDate" header="Scanned Date" sortable={true} />
          {this.state.isAdmin && (
            <Column body={this.actionTemplate} header="Action" />
          )}
        </DataTable>

        <div className="container mt-4 mb-4">
          {this.state.isAdmin && (
            <div className="col-md-12 text-center">
              <button className="btn btn-primary mt-4" onClick={this.submitForm}>
                Submit
              </button>
            </div>
          )}
        </div>

        <div className="col-md-12">
          <Loaders loader={this.state.cartoonLoader} classType="small" />
          <DataTable responsive={true} header={header2} globalFilter={this.state.globalFilter}
            emptyMessage={this.state.emptyMessage} value={this.state.sales} sortMode="multiple" paginator={true}
            rows={this.state.rows} rowsPerPageOptions={[5, 10, 20]} totalRecords={this.state.totalRecords} lazy={true}
            first={this.state.first} onPage={this.onPage} onSort={this.onSort}
            className="tblAuto">
            <Column field="DispatchId" header="Dispatch Id" sortable={true} />
            <Column field="ProductName" header="Product Name" sortable={true} />
            <Column field="BatchNumber" header="Batch Number" sortable={true} />
            <Column field="InvoiceNumber" header="Delivery Number" sortable={true} />
            <Column field="TotalTertiaryCarton" header="Total Carton" sortable={true} />
            <Column field="CreatedDt" header="Created Date" sortable={true} />
          </DataTable>
        </div>

        {/* Status Report Dialog */}
        <Dialog
          header="Dispatch Status Report"
          visible={statusReportVisible}
          onHide={this.closeStatusReport}
          style={{ width: '90%', maxWidth: '1200px' }}
          modal={true}
          closable={true}
          closeOnEscape={true}
          dismissableMask={true}
          className="status-report-dialog"
        >
          <div className="p-2">
            <div className="mb-3">
              <h4>Delivery No: {this.state.DeliveryNo}</h4>
              <hr />
            </div>
            
            {statusReportLoading && (
              <div className="text-center p-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <p className="mt-2">Fetching status report...</p>
              </div>
            )}
            
            {!statusReportLoading && statusReportData && statusReportData.length > 0 && (
              <DataTable
                value={statusReportData}
                paginator={true}
                rows={10}
                rowsPerPageOptions={[5, 10, 20, 50]}
                className="tblAuto"
                emptyMessage="No status report data available"
              >
                
                <Column field="MaterialCode" header="Material Code" sortable={true} />
                <Column field="MaterialDescription" header="Material Description" sortable={true} />
                <Column field="TotalCases" header="Total Cases" sortable={true} />
                <Column field="ScanCount" header="Scan Count" sortable={true} />
                <Column 
                  field="Status" 
                  header="Status" 
                  sortable={true}
                  body={this.statusStatusTemplate}
                />
              </DataTable>
            )}
            
            {!statusReportLoading && (!statusReportData || statusReportData.length === 0) && (
              <div className="text-center p-4">
                <i className="pi pi-info-circle" style={{ fontSize: '2rem', color: '#6c757d' }}></i>
                <p className="mt-2">No status report data available</p>
              </div>
            )}
            
            <div className="mt-3 text-right">
              <Button 
                label="Close" 
                icon="pi pi-times" 
                onClick={this.closeStatusReport} 
                className="p-button-secondary" 
                type="button" 
              />
            </div>
          </div>
        </Dialog>

        <Dialog className="popup-modal" style={{ width: '30%' }} header="Add approval remarks"
          visible={this.state.remarkVisible} modal={true} onHide={this.hideFunc}>
          <form onSubmit={this.submitRemark}>
            <div className="row">
              <div className="col-md-12">
                <label>Remark<span>*</span>:</label>
                <input type="text" style={{ width: '100%' }} value={this.state.Remark} onChange={this.handleChange}
                  className="form-control" name="Remark" />
              </div>
            </div>
            <div className="col-md-12 text-center mt-4">
              <button type="submit" className="btn btn-primary">Submit</button>
            </div>
          </form>
        </Dialog>

        <Dialog className="popup-modal" style={{ width: '500px' }} visible={this.state.visible} modal={true} onHide={this.hideFunc}>
          <form className="form-padding" autoComplete="off">
            <div className="row">
              <div className="col-md-3 text-right">
                <label>Batch<span>*</span>:</label>
              </div>
              <div className="col-md-9 mb-2">
                <input 
                  type="text" 
                  value={this.state.Batch} 
                  onChange={this.handleBatchChange} 
                  className="form-control" 
                  name="Batch" 
                  noValidate 
                />
              </div>
              <div className="col-md-12 text-center">
                <button type="submit" className="btn btn-primary" onClick={this.handleUpdateButtonClick}>
                  {this.state.buttonLabel}
                </button>
              </div>
            </div>
          </form>
        </Dialog>

        <Dialog
          header="Details"
          visible={this.state.dialogVisible}
          onHide={this.closeDialog}
          style={{ width: '80vw' }}
        >
          <DataTable value={this.state.apiData} paginator rows={10} className="datatable">
            <Column field="field1" header="Field 1" />
            <Column field="field2" header="Field 2" />
            <Column field="field3" header="Field 3" />
          </DataTable>
          <Button label="Close" onClick={this.closeDialog} />
        </Dialog>
      </>
    );
  }
}